import script from "./settings-section.vue?vue&type=script&setup=true&lang=js"
export * from "./settings-section.vue?vue&type=script&setup=true&lang=js"

import "./settings-section.vue?vue&type=style&index=0&id=a259c5f4&lang=scss"
import "./settings-section.vue?vue&type=style&index=1&id=a259c5f4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a259c5f4"]])

export default __exports__